enum ENUM_HOST {
    PUBSUB_DEV = 'http://172.16.115.183:4000/pubsub',
    PUBSUB_PROD = 'https://api.wehago.com/pubsub',

    AUTH = 'https://api.wehago.com',
    PUBLIC = 'https://api0.wehago.com',

    PUBLIC_GET_OEKN = 'https://api0.wehago.com/get_token/?url=',
}

enum ENUM_ENDPOINT {
    ENROLLTICKET = '/common/cs/enrollticket',
    COMPANY_BOARD = '/companyboard/dashboard/contents?&cno=9',
}

enum ENUM_COOKIE_NAME {
    CNO = 'h_selected_company_no',
    AUTH = 'AUTH_A_TOKEN',
}

enum ENUM_API_TYPE {
    POST = 'POST',
    GET = 'GET'
}

export { ENUM_HOST, ENUM_API_TYPE, ENUM_COOKIE_NAME, ENUM_ENDPOINT };
